import { OHAIO_API_URL } from '@/constants/value.js'
import { useRoomInfo } from '@/services/roomInfoService'

export async function useSendMailService({ received_user_emails, room_id, target_language }) {
    const url = `${OHAIO_API_URL}/v1/transcription/send-mail`;
    const data = {
        received_user_emails,
        room_id,
        target_language,
    };

    let isSharing = false;
    try {
        const roomInfo = await useRoomInfo({ roomId: room_id });
        isSharing = roomInfo.is_sharing || false;
    } catch (error) {
        isSharing = false;
    }

    if (!isSharing) {
        throw new Error('Room is not sharing. Mail will not be sent.');
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    await new Promise(resolve => setTimeout(resolve, 2500));

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
}